module.exports = __webpack_public_path__ + "media/customizations/brookwaterlife/logo-e2f7bdf5b242360224c3121fc85cb8ef.png";